import React, { useEffect, useState } from "react";
import { Trophy, Check, Star, Lock, PartyPopper } from "lucide-react";
import { T } from "./theme";

const KEY = "cc_journey_seen";

export const JourneyCard = ({ j }) => {
  const [celebrate, setCelebrate] = useState(false);
  useEffect(() => {
    const prev = Number(localStorage.getItem(KEY) || 0);
    if (j.on_time_count > prev && prev > 0) setCelebrate(true);
    localStorage.setItem(KEY, String(j.on_time_count));
  }, [j.on_time_count]);
  return (
    <section className="relative overflow-hidden rounded-[26px] p-5 text-white" data-testid="journey-card"
      style={{ background: "linear-gradient(140deg, #2A0E4F 0%, #45198A 70%, #5B23A3 100%)" }}>
      <div className="flex items-center gap-2">
        <Trophy size={20} style={{ color: "#E3C99A" }} />
        <h2 className="text-[17px] font-extrabold">Minha jornada de pontualidade</h2>
      </div>
      <p className="mt-1 text-[14px] text-white/80">Cada pagamento em dia fortalece seu histórico!</p>
      {celebrate && (
        <div className="cc-pop mt-3 flex items-center gap-2 rounded-2xl px-3 py-2 text-[14px] font-semibold" role="status"
          style={{ background: "rgba(227,201,154,0.18)", color: "#F3E6C8" }} data-testid="journey-celebration">
          <PartyPopper size={18} /> Parabéns! Você conquistou {j.on_time_count} pagamento{j.on_time_count > 1 ? "s" : ""} em dia.
        </div>
      )}
      <ol className="mt-5 grid grid-cols-5 gap-1" data-testid="journey-steps">
        {j.steps.map((st, idx) => (
          <li key={st.n} className="flex flex-col items-center text-center" data-testid={`journey-step-${st.n}-${st.state}`}>
            <span className="cc-pop flex h-11 w-11 items-center justify-center rounded-full border-2" style={{
              animationDelay: `${idx * 90}ms`,
              background: st.state === "done" ? T.green : st.state === "next" ? T.gold : "rgba(255,255,255,0.08)",
              borderColor: st.state === "locked" ? "rgba(255,255,255,0.25)" : "transparent",
            }}>
              {st.state === "done" ? <Check size={20} strokeWidth={3} /> : st.state === "next" ? <Star size={18} fill="#fff" /> : <Lock size={15} className="text-white/60" />}
            </span>
            <span className="mt-1.5 text-[11px] font-bold leading-tight">{st.n}º</span>
            <span className="text-[10px] leading-tight text-white/70">{st.state === "done" ? "Em dia" : st.state === "next" ? "Próximo" : "Futuro"}</span>
          </li>
        ))}
      </ol>
      <div className="mt-5 rounded-2xl px-4 py-3" style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(227,201,154,0.35)" }} data-testid="journey-next">
        <div className="text-[14px] font-extrabold" style={{ color: "#E3C99A" }}>
          Sua próxima conquista: {j.next_milestone} pagamento{j.next_milestone > 1 ? "s" : ""} em dia
        </div>
        <div className="mt-0.5 text-[13px] text-white/80">Continue assim e fortaleça seu histórico para futuras oportunidades!</div>
        <div className="mt-1 text-[11px] text-white/60" data-testid="journey-count">
          {j.on_time_count} parcela{j.on_time_count === 1 ? "" : "s"} quitada{j.on_time_count === 1 ? "" : "s"} até o vencimento
        </div>
      </div>
    </section>
  );
};
